import { Feature } from '../earlyAccessWidget.types'

export const FEATURES: Feature[] = []

export const FEATURE_COUNT_BADGE_COOKIE = 'early-access-badge'
export const FEATURE_COUNT_BADGE_VALUE = 'viewed'
export const FEATURE_COUNT_DEFAULT_VALUE = 0
export const RATE_LIMIT_ERROR_CODE = 'API_ERROR'
export const RATE_LIMIT_ERROR_MESSAGE = 'LaunchDarkly API rate limit reached'
export const CAPACITY_LIMIT_ERROR_CODE = 'FAILED_PRECONDITION'
const CAPACITY_LIMIT_WAIT_LIST =
  'https://docs.google.com/forms/d/e/1FAIpQLSeQt6floCX54f2R_m40qFiyCs1ZE7Xrfzn6pb5XDcbG6XKlfA/viewform'

export const ERROR_MAX_CAPACITY_TOAST_CONTENT = {
  title: 'The beta is full',
  description: 'We’ve reached capacity for users to test this feature.',
  shouldCloseManually: true,
  action: {
    label: 'Click here to join the waitlist',
    handler: () => {
      window.open(CAPACITY_LIMIT_WAIT_LIST, '_blank')
    },
  },
  className: 'font-size-fix',
}
